import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 获取验证码
export function getCaptcha() {
  return request({
    url: '/captcha',
    method: 'get'
  })
}

// 登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

/**
 * 修改个人密码
 * @param {Object} data 包含oldPassword和newPassword的对象
 * @returns {Promise}
 */
export function changePassword(data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data
  })
}

// 获取所有用户（不分页）- 仅用于下拉列表等场景
export function getAllUsers(params) {
  return request({
    url: '/users/list',
    method: 'post',
    data: params || {}
  })
}

// 分页查询用户 - 用于表格展示
export function searchUsers(params) {
  return request({
    url: '/users/search',
    method: 'post',
    data: params || {}
  })
}

/**
 * 重置用户密码
 * @param {String|Number} userId 用户ID
 * @returns {Promise}
 */
export function resetUserPassword(userId) {
  return request({
    url: `/users/${userId}/reset-password`,
    method: 'post'
  })
}

/**
 * 修改用户角色
 * @param {Object} data 包含userId和roleId的对象
 * @returns {Promise}
 */
export function updateUserRole(data) {
  return request({
    url: '/users/update-role',
    method: 'post',
    data
  })
}

/**
 * 修改用户健康评级
 * @param {Object} data 包含userId和healthRatingId的对象
 * @returns {Promise}
 */
export function updateUserHealthRating(data) {
  return request({
    url: '/users/update-health-rating',
    method: 'post',
    data
  })
} 